module.exports = __webpack_public_path__ + "new_tag_l.png?0acaefa3ad4d896618d3f115d9f0b7de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_tag_l.png
// module id = 563
// module chunks = 0